import type { PagedResultDto } from "@services/dto/pagedResultDto"
import offsetAccountService from "@services/master-data/accountingData/offsetAccountService"
import { action, makeAutoObservable, observable } from "mobx"

class OffsetAccountStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }
  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await offsetAccountService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }
  @action
  async initDetail() {
    this.detailData = {
      id: 0,
    }
  }
  @action
  async active(id: number, isActive) {
    this.isLoading = true
    await offsetAccountService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
  }
  @action
  async get(id: number) {
    this.isLoading = true
    const result = await offsetAccountService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }
  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await offsetAccountService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async export(params: any) {
    this.isLoading = true
    await offsetAccountService
      .export(params)
      .finally(() => (this.isLoading = false))
  }
  @action
  public import = async (file: File) => {
    this.isLoading = true
    try {
      const result = await offsetAccountService
        .impport(file)
        .finally(() => (this.isLoading = false))

      return result
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }
}

export default OffsetAccountStore
